import React, { useState } from 'react';
import { Grid } from "@mui/material";
import MKTypography from "../../../components/MKTypography";
import MKBox from "../../../components/MKBox";
import MKButton from "../../../components/MKButton";
// import WarningIcon from '@mui/icons-material/Warning';
import TextField from '@mui/material/TextField';
import { withStyles } from "@material-ui/core/styles";
import { useEffect } from 'react';
import PhoneInput from 'react-phone-number-input';
import CustomPhoneNumber from "../../../components/contactusPhone";
import { isValidPhoneNumber } from 'react-phone-number-input';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormHelperText from '@mui/material/FormHelperText';
import clsx from "clsx";
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';

import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Lottie from "lottie-react";
import growLoader from "../../../assets/animation/growLoader.json";
import { premiumContactUs } from "../../../providers/newsletter";

const ipify = require('ipify2');
const ipLocation = require('iplocation');


const MyTextField = withStyles(() => ({
    root: {
        "&.MuiInputLabel": {
            fontFamily: "OpenSansRegular"
        },
        "& .MuiFormLabel-asterisk.MuiInputLabel-asterisk": {
            color: "#F7931E",
            fontSize: "14px",
        },
        "& .MuiInput-root": {
            fontSize: "14px",
            fontFamily: "OpenSansMedium"
        },
        "& .MuiFormHelperText-root": {
            color: "#FF4040",
            fontFamily: "OpenSansMedium",
            fontSize: "12px",
        },
        "& .MuiFormLabel-root.Mui-error": {
            color: "#FF4040",
            fontSize: "12px",
            fontFamily: "OpenSansRegular",
        }
    }
}))(TextField)

const MyFormField = withStyles(() => ({
    root: {
        "& .MuiInput-root": {
            fontSize: "14px",
            fontFamily: "OpenSansMedium"
        },
        "& .MuiInputBase-input:focus": {
            backgroundColor: "#FFFFFF"
        },
        "& .MuiFormHelperText-root": {
            color: "#FF4040",
            fontFamily: "OpenSansMedium",
            fontSize: "12px",
        },
        "& .MuiFormLabel-root.Mui-error": {
            color: "#FF4040",
            fontSize: "12px",
            fontFamily: "OpenSansRegular",
        }
    }
}))(FormControl)

const MyInputLabel = withStyles(() => ({
    root: {
        "& .MuiInputLabel-asterisk": {
            color: "#F7931E",
        }
    }
}))(InputLabel)

const iconStyles = {
    selectIcon: {
        color: "#8C9196"
    }
};


const CustomExpandMore = withStyles(iconStyles)(
    ({ className, classes, ...rest }) => {
        return (
            <KeyboardArrowDownIcon
                {...rest}
                className={clsx(className, classes.selectIcon)}
            />
        );
    }
);


const PremiumContactUsModal = ({ toggleContactUsModal }) => {

    const [fields, setFields] = useState({
        business_name: "",
        contact_name: "",
        email: "",
    });
    const [monthlySaleOption, setMonthlySaleOption] = useState("")
    const [locationCout, setLocationCount] = useState("")
    const [numberOfStaff, setNumberOfStaff] = useState("")
    const [numOfPosMachines, setNumOfPosMachines] = useState("")
    const [sellOnlineValue, setSellOnlineValue] = useState("")
    const [currentSoftwareBilling, setCurrentSoftwareBilling] = useState("")
    const [anyIssuesArray, setAnyIssuesArray] = useState([])
    // const [featureNeeded, setFeatureNeeded] = useState([])
    const [spendingOnSoftware, setSpendingOnSoftware] = useState("")
    const [whenToPlanChange, setwhenToPlanChange] = useState("")
    const [otherValue, setOtherValue] = useState("");
    const [otherFeildError, setOtherFeildError] = useState(false);


    const [formError, setFormError] = useState({});
    const [phone, setPhone] = useState("");
    const [phoneError, setPhoneError] = useState(false)
    const [emailValidError, setEmailValidError] = useState(false);
    const [showForm, setShowForm] = useState(true)
    const [showConfirm, setShowConfirm] = useState(false)
    const [showLoading, setShowLoading] = useState(false)

    const [navigator, setNavigator] = useState(typeof window !== "undefined" ? window.navigator.userAgent : "")
    const [ipv4v, setIpv4] = useState("")
    const [ipv6, setIpv6] = useState("")
    const [region, setRegion] = useState("")
    useEffect(() => {
            let isMounted = true;
            
            const timeoutId = setTimeout(async () => {
                if (!isMounted) return;
                
                try {
                    const ipv4 = await ipify.ipv4();
                    if (isMounted) setIpv4(ipv4);
                    
                    const ipv64 = await ipify.ipv64();
                    if (isMounted) setIpv6(ipv64);
                    
                    if (ipv4 !== "" && isMounted) {
                        const loc = await ipLocation(ipv4);
                        if (isMounted) setRegion(loc["city"] + " " + loc["region"]["code"] + " " + loc["country"]["code"]);
                    }
                } catch (err) {
                    console.log(err);
                }
            }, 2000);
            
            return () => {
                isMounted = false;
                clearTimeout(timeoutId);
            };
        }, [])
    const updateContactUSForm = async () => {

        setFormError(validateFields());
        if (Object.keys(validateFields()).length === 0) {
            const featureNeeded = `Inventory / stock tracking - ${priOptionOne} | Sales reports - ${priOptionTwo} | Online store connection - ${priOptionThree} | Multi-shop handling - ${priOptionFour} | Purchase order system - ${priOptionFive} | Staff management - ${priOptionSix} | Accounting link (like Tally) - ${priOptionSeven}`
            console.log(fields)
            console.log(monthlySaleOption)
            console.log(locationCout)
            console.log(numberOfStaff)
            console.log(numOfPosMachines)
            console.log(sellOnlineValue)
            console.log(anyIssuesArray)
            console.log(featureNeeded)
            console.log(spendingOnSoftware)
            console.log(whenToPlanChange)
            console.log(phone)
            console.log(currentSoftwareBilling)

            console.log(otherValue)
            if (otherValue !== ''){
                anyIssuesArray.push(`Other-${otherValue}`)
            }
            const post_obj = {
                "email": fields.email.toLowerCase(),
                "business_name": fields.business_name,
                "contact_name": fields.contact_name,
                "phone": phone,
                "monthly_sale": monthlySaleOption,
                "number_of_locations": locationCout,
                "number_of_staff": numberOfStaff,
                "number_of_pos_machines": numOfPosMachines,
                "selling_online": sellOnlineValue,
                "current_software": currentSoftwareBilling,
                "any_issues": anyIssuesArray,
                "priority_features": featureNeeded,
                "spending_on_billing_software": spendingOnSoftware,
                "when_to_change": whenToPlanChange,
                "ipv4_Address": ipv4v,
                "ipv6_Address": ipv6,
                "location": region,
                "userAgent": navigator,
            }

            const response = await premiumContactUs(post_obj)
            if (response?.data?.status === 200) {
                setShowForm(false)
                setShowLoading(true);
                setTimeout(() => {
                    setShowLoading(false)
                    setShowConfirm(true)
                }, 3000);
            }
            

            
        }

    }

    const styleobj = {
        marginTop: "36px",
        borderBottom: "2px solid #BABFC5",
    }

    const validateFields = () => {
        let errors = {}
        for (let key in fields) {
            if (fields[key] === "") {
                errors[key] = true
            }
        }
        if (!phone || phone === "") {
            errors['phone'] = true
            setPhoneError(true);
        }
        if (monthlySaleOption === "") {
            errors['monthlySaleOption'] = true
        }
        if (locationCout === "") {
            errors['locationCout'] = true
        }
        if (numberOfStaff === "") {
            errors['numberOfStaff'] = true
        }
        if (numOfPosMachines === "") {
            errors['numOfPosMachines'] = true
        }
        if (sellOnlineValue === "") {
            errors['sellOnlineValue'] = true
        }
        if (currentSoftwareBilling === "") {
            errors['currentSoftwareBilling'] = true
        }
        // if (spendingOnSoftware === "") {
        //     errors['spendingOnSoftware'] = true
        // }
        // if (whenToPlanChange === "") {
        //     errors['whenToPlanChange'] = true
        // }
        // if (anyIssuesArray?.length === 0) {
        //     errors['anyIssuesArray'] = true
        // }

        // if (anyIssuesArray.includes("Other")) {
        //     if (otherValue === "") {
        //         setOtherFeildError(true);
        //     }
        // }
        return errors;
    }

    const handleInputChange = (e) => {
        delete formError[e.target.name]
        setFormError(formError)
        setFields({ ...fields, [e.target.name]: e.target.value })
    }

    const handlePhoneInputChange = (event) => {
        setPhone(event)
        delete formError['phone']
        setFormError(formError)
        // 
    }

    const validatePhone = (event) => {
        console.log('event', event.target.value);
        const result = isValidPhoneNumber(String(event.target.value))
        console.log("result", result);
        if (!result) {
            setFormError({ ...formError, 'phone': true })
        } else {
            delete formError['phone']
            setFormError(formError)
        }
    }

    const handleAllowedOption = (event, feildName) => {
        const { value } = event.target;
        console.log("value", value)
        console.log("feildName", feildName)

        if (feildName === "MONTHLY_SALE") {
            setMonthlySaleOption(value)
            delete formError['monthlySaleOption']
        } else if (feildName === "LOCATION_COUNT") {
            delete formError['locationCout']
            setLocationCount(value)
        } else if (feildName === "STAFF_NUMBER") {
            delete formError['numberOfStaff']
            setNumberOfStaff(value)
        } else if (feildName === "POS_MACHINE") {
            delete formError['numOfPosMachines']
            setNumOfPosMachines(value)
        } else if (feildName === "ONLINE_SELLING") {
            setSellOnlineValue(value)
            delete formError['sellOnlineValue']
        } else if (feildName === "CURRENT_SOFTWARE") {
            setCurrentSoftwareBilling(value)
            delete formError['currentSoftwareBilling']
        } else if (feildName === "SPENDING_ON_SOFTWARE") {
            setSpendingOnSoftware(value)
            delete formError['spendingOnSoftware']
        } else if (feildName === "PLAN_CHANGE") {
            setwhenToPlanChange(value)
            delete formError['whenToPlanChange']
        }
        setFormError(formError)
    }




    const monthlySaleAprOption = [
        "Below ₹1 lakh",
        "₹1-5 lakh",
        "₹5-15 lakh",
        "₹15-50 lakh",
        "Above ₹50 lakh"
    ]

    const locationCount = [
        "1 only",
        "2-3",
        "4-10",
        "10+"
    ]

    const numOfStaff = [
        "Just me",
        "2-5",
        "6-15",
        "15+"
    ]

    const posMachines = [
        "1",
        "2-3",
        "4-10",
        "10+"
    ]

    const sellOnline = [
        "Yes, own website/app",
        "Yes, Amazon/Flipkart etc",
        "Planning to start",
        "Only physical shop"
    ]

    const currentSoftBilling = [
        "Handwritten bills",
        "Tally/computer software",
        "Mobile app",
        "Mix of methods"
    ]

    const anyIssues = [
        "High software cost",
        "Inventory tracking problem",
        "Online+offline mismatch",
        "Difficult to use",
        "Bad customer support",
        "Cannot manage multiple shops",
        "Other"
    ]


    const featureYouWant = [
        "Inventory / stock tracking",
        "Sales reports",
        "Online store connection",
        "Multi-shop handling",
        "Purchase order system",
        "Staff management",
        "Accounting link (like Tally)",
    ]

    const spendingOnSoft = [
        "Nothing (free)",
        "Under ₹5,000",
        "₹5,000 - ₹10,000",
        "₹10,000+"
    ]

    const whenPlanChange = [
        "Immediately",
        "1-3 months",
        "3-6 months",
        "Not sure"
    ]

    const priority = [
        "1",
        "2",
        "3"
    ]


    const handleAyIssue = (event) => {
        let issueArray = anyIssuesArray;
        console.log('event.checked', event.target.checked)
        console.log('event.value', event.target.value)
        const check = event.target.checked;
        const value = event.target.value;
        if (check) {
            issueArray.push(value)
            delete formError['anyIssuesArray']
            setFormError(formError)
        } else {
            const index = issueArray.indexOf(value);
            if (index > -1) { // only splice array when item is found
                issueArray.splice(index, 1); // 2nd parameter means remove one item only
            }
        }
        if (value === 'Other' && !check) {
            setOtherFeildError(false);
        }
        console.log('issueArray', issueArray);
        setAnyIssuesArray(issueArray)
    }

    const [priorityArray, setPriorityArray] = useState([
        "Inventory / stock tracking",
        "Sales reports",
        "",
        "",
        "",
        "",
        "",
    ])

    const [priOptionOne, setPriOptionOne] = useState(0);
    const [priOptionTwo, setPriOptionTwo] = useState(0);
    const [priOptionThree, setPriOptionThree] = useState(0);
    const [priOptionFour, setPriOptionFour] = useState(0);
    const [priOptionFive, setPriOptionFive] = useState(0);
    const [priOptionSix, setPriOptionSix] = useState(0);
    const [priOptionSeven, setPriOptionSeven] = useState(0);


    const handlePriorityOption = (e, option) => {
        const { value } = e.target;
        console.log('value', value);
        if (option === "Inventory / stock tracking"){
            setPriOptionOne(value)
        } else if (option === "Sales reports") {
            setPriOptionTwo(value)
        } else if (option === "Online store connection") {
            setPriOptionThree(value)
        } else if (option === "Multi-shop handling") {
            setPriOptionFour(value)
        } else if (option === "Purchase order system") {
            setPriOptionFive(value)
        } else if (option === "Staff management") {
            setPriOptionSix(value)
        } else if (option === "Accounting link (like Tally)") {
            setPriOptionSeven(value)
        }

        // let priArray = featureNeeded;
        // priArray[value - 1] = option;
        // setFeatureNeeded(priArray);
    }


    const emailValidation = (email) => {
        const email_pattern = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/;
        if (!email_pattern.test(email)) {
            setEmailValidError(true)
            return false;
        } else {
            setEmailValidError(false)
            return true;
        }
    }
    return (
        <>
            <div className="addressEditmodal">
                <div className="overlay"><></></div>
                {showForm &&
                    <div className="contacus-modal-content">
                        <MKTypography fontSize="24px" style={{ color: "#202223", letterSpacing: "0.4px", textAlign: "left", opacity: 1, margin: '40px', marginBottom: '0px' }}> <span > Connect with Our Team</span></MKTypography>
                        <Grid display={"flex"} sx={{ px: { lg: 4 } }} flexDirection={'row'} flexWrap={'wrap'} justifyContent="space-between" maxWidth="lg" style={{ overflowX: "hidden", width: '100%' }} mb={5}  >

                            <Grid sx={{ justifyContent: 'center', width: { xs: "100%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' } }} >

                                <MyTextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="business_name"
                                    label="Business Name"
                                    name="business_name"
                                    value={fields.business_name}
                                    error={formError.business_name}
                                    helperText={formError.business_name ? "Business Name is required" : ''}
                                    onChange={handleInputChange}
                                    variant="standard"
                                    InputLabelProps={{
                                        style: { fontFamily: "OpenSansRegular" }
                                    }}
                                />
                            </Grid>
                            <Grid sx={{ justifyContent: 'center', width: { xs: "100%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' } }}>
                                <MyTextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="contact_name"
                                    label="Contact Name"
                                    name="contact_name"
                                    value={fields.contact_name}
                                    error={formError.contact_name}
                                    helperText={formError.contact_name ? "Contact Name is required" : ''}
                                    onChange={handleInputChange}
                                    variant="standard"
                                    InputLabelProps={{
                                        style: { fontFamily: "OpenSansRegular" }
                                    }}
                                />
                            </Grid>
                            <Grid sx={{ justifyContent: 'center', width: { xs: "100%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' } }}>
                                <PhoneInput
                                    style={styleobj}
                                    defaultCountry={'IN'}
                                    inputComponent={CustomPhoneNumber}
                                    value={phone}
                                    onChange={handlePhoneInputChange}
                                    onBlur={validatePhone}
                                    error={phoneError || formError.phone}
                                    helperText={formError.phone ? "Phone Number is required" : phoneError ? "Phone Number is not valid" : ""}
                                    disabled={false}
                                    className='contactus'
                                    international  
                                />
                            </Grid>

                            <Grid sx={{ justifyContent: 'center', width: { xs: "100%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' } }}>
                                <MyTextField
                                    margin="normal"
                                    fullWidth
                                    required
                                    id="email"
                                    label="Email Address"
                                    name="email"
                                    value={fields.email}
                                    error={formError.email || emailValidError}
                                    helperText={formError.email ? "Email address is required" : emailValidError ? "Please enter a valid email address"
                                        : ""}
                                    onBlur={(e) => emailValidation(e.target.value)}
                                    onChange={handleInputChange}
                                    variant="standard"
                                    InputLabelProps={{
                                        style: { fontFamily: "OpenSansRegular" }
                                    }}
                                />
                            </Grid>

                            <Grid sx={{ justifyContent: 'center', width: { xs: "100%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' }, mt: '16px', mb: '8px' }}>
                                <MyFormField required fullWidth variant="standard">
                                    <MyInputLabel style={{ fontFamily: "OpenSansRegular" }}>What is your monthly sales approximately?</MyInputLabel>

                                    <Select
                                        variant="standard"
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label=""
                                        name="monthlySaleOption"
                                        value={monthlySaleOption}
                                        IconComponent={CustomExpandMore}
                                        error={formError.monthlySaleOption}
                                        helperText={formError.monthlySaleOption ? "Please select an option" : ""}
                                        onChange={(e) => { handleAllowedOption(e, "MONTHLY_SALE") }}
                                        sx={{
                                            marginTop: '20px'
                                        }}
                                    >
                                        {monthlySaleAprOption.map((element) => <MenuItem key={element} value={element} sx={{ fontFamily: "OpenSansRegular" }}>{element}</MenuItem>)}


                                    </Select>
                                    <FormHelperText>{formError.monthlySaleOption ? "Please select an option" : ""}</FormHelperText>


                                </MyFormField>
                            </Grid>

                            <Grid sx={{ justifyContent: 'center', width: { xs: "100%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' }, mt: '16px', mb: '8px' }}>
                                <MyFormField required fullWidth variant="standard">
                                    <MyInputLabel style={{ fontFamily: "OpenSansRegular" }}>How many locations do you have?</MyInputLabel>

                                    <Select
                                        variant="standard"
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label=""
                                        name="locationCout"
                                        value={locationCout}
                                        IconComponent={CustomExpandMore}
                                        error={formError.locationCout}
                                        helperText={formError.locationCout ? "Please select an option" : ""}
                                        onChange={(e) => { handleAllowedOption(e, "LOCATION_COUNT") }}
                                        sx={{
                                            marginTop: '20px'
                                        }}
                                    >
                                        {locationCount.map((element) => <MenuItem key={element} value={element} sx={{ fontFamily: "OpenSansRegular" }}>{element}</MenuItem>)}


                                    </Select>
                                    {formError.locationCout &&
                                        <FormHelperText color='#FF4040' sx={{ color: '#FF4040' }}>Please select an option</FormHelperText>

                                    }


                                </MyFormField>
                            </Grid>


                            <Grid sx={{ justifyContent: 'center', width: { xs: "100%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' }, mt: '16px', mb: '8px' }}>
                                <MyFormField required fullWidth variant="standard">
                                    <MyInputLabel style={{ fontFamily: "OpenSansRegular" }}>Number of staff working?</MyInputLabel>

                                    <Select
                                        variant="standard"
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Store Location"
                                        name="numberOfStaff"
                                        value={numberOfStaff}
                                        IconComponent={CustomExpandMore}
                                        error={formError.numberOfStaff}
                                        helperText={formError.numberOfStaff ? "Please select an option" : ""}
                                        onChange={(e) => { handleAllowedOption(e, "STAFF_NUMBER") }}
                                        sx={{
                                            marginTop: '20px'
                                        }}
                                    >
                                        {numOfStaff.map((element) => <MenuItem key={element} value={element} sx={{ fontFamily: "OpenSansRegular" }}>{element}</MenuItem>)}


                                    </Select>
                                    <FormHelperText>{formError.numberOfStaff ? "Please select an option" : ""}</FormHelperText>


                                </MyFormField>
                            </Grid>


                            <Grid sx={{ justifyContent: 'center', width: { xs: "100%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' }, mt: '16px', mb: '8px' }}>
                                <MyFormField required fullWidth variant="standard">
                                    <MyInputLabel style={{ fontFamily: "OpenSansRegular" }}>How many billing counters/POS machines?</MyInputLabel>

                                    <Select
                                        variant="standard"
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Store Location"
                                        name="numOfPosMachines"
                                        value={numOfPosMachines}
                                        IconComponent={CustomExpandMore}
                                        error={formError.numOfPosMachines}
                                        helperText={formError.numOfPosMachines ? "Please select an option" : ""}
                                        onChange={(e) => { handleAllowedOption(e, "POS_MACHINE") }}
                                        sx={{
                                            marginTop: '20px'
                                        }}
                                    >
                                        {posMachines.map((element) => <MenuItem key={element} value={element} sx={{ fontFamily: "OpenSansRegular" }}>{element}</MenuItem>)}


                                    </Select>
                                    <FormHelperText>{formError.numOfPosMachines ? "Please select an option" : ""}</FormHelperText>


                                </MyFormField>
                            </Grid>


                            <Grid sx={{ justifyContent: 'center', width: { xs: "100%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' }, mt: '16px', mb: '8px' }}>
                                <MyFormField required fullWidth variant="standard">
                                    <MyInputLabel style={{ fontFamily: "OpenSansRegular" }}>Do you sell online also?</MyInputLabel>

                                    <Select
                                        variant="standard"
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label=""
                                        name="sellOnlineValue"
                                        value={sellOnlineValue}
                                        IconComponent={CustomExpandMore}
                                        error={formError.sellOnlineValue}
                                        helperText={formError.sellOnlineValue ? "Please select an option" : ""}
                                        onChange={(e) => { handleAllowedOption(e, "ONLINE_SELLING") }}
                                        sx={{
                                            marginTop: '20px'
                                        }}
                                    >
                                        {sellOnline.map((element) => <MenuItem key={element} value={element} sx={{ fontFamily: "OpenSansRegular" }}>{element}</MenuItem>)}


                                    </Select>
                                    <FormHelperText>{formError.sellOnlineValue ? "Please select an option" : ""}</FormHelperText>



                                </MyFormField>
                            </Grid>


                            <Grid sx={{ justifyContent: 'center', width: { xs: "100%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' }, mt: '16px', mb: '8px' }}>
                                <MyFormField required fullWidth variant="standard">
                                    <MyInputLabel style={{ fontFamily: "OpenSansRegular" }}>Current software for billing?</MyInputLabel>

                                    <Select
                                        variant="standard"
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Store Location"
                                        name="currentSoftwareBilling"
                                        value={currentSoftwareBilling}
                                        IconComponent={CustomExpandMore}
                                        error={formError.currentSoftwareBilling}
                                        onChange={(e) => { handleAllowedOption(e, "CURRENT_SOFTWARE") }}
                                        sx={{
                                            marginTop: '20px'
                                        }}
                                    >

                                        {currentSoftBilling.map((element) => <MenuItem key={element} value={element} sx={{ fontFamily: "OpenSansRegular" }}>{element}</MenuItem>)}


                                    </Select>
                                    <FormHelperText>{formError.currentSoftwareBilling ? "Please select an option" : ""}</FormHelperText>
                                </MyFormField>
                            </Grid>


                            <Grid sx={{ justifyContent: 'center', width: { xs: "100%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' }, mt: '16px', mb: '8px' }}>

                                <MKTypography fontSize="16px" mt={2} className="semi-bold" style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1 }}>Any issues you face?</MKTypography>


                                {anyIssues.map((ele, index) => {
                                    return (
                                        <>
                                            <MKBox key={ele + index} sx={{ display: "flex", color: "#202223", flexDirection: 'column' }}>

                                                {ele === 'Other' ?
                                                    <>
                                                        <MKBox sx={{ display: "flex", color: "#202223", }}>
                                                            <FormControlLabel color='#202223' sx={{ color: "#202223" }} value={ele} control={<Checkbox sx={{
                                                                color: '#50B748',
                                                                '&.Mui-checked': {
                                                                    color: '#50B748',
                                                                },

                                                            }} onChange={handleAyIssue} />} label={ele} />
                                                            <input required={otherFeildError} error={otherFeildError} onChange={(e) => setOtherValue(e.target.value)} className='otherOptionInput' />

                                                        </MKBox>
                                                        <span style={{ marginLeft: "88px", marginTop: "4px", fontSize: '12px', color: '#FF4040', fontFamily: "OpenSansRegular", marginTop: '4px' }}>{otherFeildError ? "Please fill this field" : ""}</span>

                                                    </>
                                                    :
                                                    <FormControlLabel key={ele + index} value={ele} control={<Checkbox sx={{
                                                        color: '#50B748',
                                                        '&.Mui-checked': {
                                                            color: '#50B748',
                                                        },

                                                    }} onChange={handleAyIssue} />} label={ele} />
                                                }

                                            </MKBox>
                                        </>
                                    )
                                })
                                }
                                {/* <span style={{ fontSize: '12px', color: '#FF4040', fontFamily: "OpenSansRegular", marginTop: '4px' }}>{formError.anyIssuesArray ? "Please select an option" : ""}</span> */}

                            </Grid>


                            <Grid sx={{ justifyContent: 'center', width: { xs: "100%", sm: "70%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' }, mt: '16px', mb: '8px' }}>

                                <MKTypography fontSize="16px" mt={2} className="semi-bold" style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1 }}>Which features you want most?</MKTypography>

                                <MKTypography fontSize="14px" sx={{ color: "#0000008A", pt: 0.5 }}>
                                    (Please select number 1 to 3, 1 = top priority)
                                </MKTypography>
                                <RadioGroup
                                    column
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    sx={{ display: "flex", mt: 2 }}
                                >
                                    {featureYouWant.map((ele, index) =>
                                        <MKBox key={ele + index} sx={{ display: "flex", justifyContent: 'space-between' }}>
                                            <MKTypography sx={{ height: '40px' }}>
                                                {ele}
                                            </MKTypography>
                                            <Select
                                                variant="standard"
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Store Location"
                                                name="featureNeeded"
                                                IconComponent={CustomExpandMore}
                                                onChange={(e) => { handlePriorityOption(e, ele) }}
                                                sx={{
                                                    width: '100px',
                                                    height: "25px",
                                                    mr: { xs: '0px', sm: "80px" }

                                                }}
                                            >
                                                {priority.map((element) => <MenuItem key={element} value={element} sx={{ fontFamily: "OpenSansRegular" }}>{element}</MenuItem>)}


                                            </Select>
                                        </MKBox>
                                    )}

                                </RadioGroup>
                            </Grid>

                            <Grid sx={{ width: "100%", display: 'flex', justifyContent: "space-between", flexDirection: { lg: 'row', xs: 'column' } }}>
                                <Grid sx={{ justifyContent: 'center', width: { xs: "100%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' }, mt: '16px', mb: '8px' }}>
                                    <MyFormField required fullWidth variant="standard">

                                        <MKTypography fontSize="16px" mt={2} className="semi-bold" style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1 }}>What do you spend on billing software per month approximately?</MKTypography>

                                        <RadioGroup
                                            onChange={(e) => { handleAllowedOption(e, "SPENDING_ON_SOFTWARE") }}
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="spendingOnSoftware"
                                            value={spendingOnSoftware}
                                            sx={{ display: "flex", mt: 2, flexDirection: { xs: "row", lg: "column" } }}
                                        >
                                            {spendingOnSoft.map((ele, index) => <FormControlLabel key={ele + index} value={ele} control={<Radio sx={{
                                                color: '#50B748',
                                                '&.Mui-checked': {
                                                    color: '#50B748',
                                                },

                                            }} />} label={ele} />)}

                                        </RadioGroup>
                                        {/* <FormHelperText>{formError.spendingOnSoftware ? "Please select an option" : ""}</FormHelperText> */}

                                    </MyFormField>
                                </Grid>

                                <Grid sx={{ justifyContent: 'center', width: { xs: "100%", lg: '45%' }, px: { xs: "12px", sm: "40px", lg: '0px' }, mt: '16px', mb: '8px' }}>
                                    <MyFormField required fullWidth variant="standard">

                                        <MKTypography fontSize="16px" mt={2} className="semi-bold" style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1 }}>When do you plan to change or upgrade?</MKTypography>

                                        <RadioGroup
                                            onChange={(e) => { handleAllowedOption(e, "PLAN_CHANGE") }}
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="whenToPlanChange"
                                            value={whenToPlanChange}
                                            sx={{ display: "flex", mt: 2, flexDirection: { xs: "row", lg: "column" } }}
                                        >
                                            {whenPlanChange.map((ele, index) => <FormControlLabel key={ele + index} value={ele} control={<Radio sx={{
                                                color: '#50B748',
                                                '&.Mui-checked': {
                                                    color: '#50B748',
                                                },

                                            }} />} label={ele} />)}

                                        </RadioGroup>
                                        {/* <FormHelperText>{formError.whenToPlanChange ? "Please select an option" : ""}</FormHelperText> */}

                                    </MyFormField>
                                </Grid>
                            </Grid>



                        </Grid>
                        <Grid lg={12} sx={{
                            mt: '32px',
                            mb: '32px',
                            pr: { sm: '64px', xs: '0px' },

                            justifyContent: { sm: "end", xs: 'center' }, alignContent: { sm: "end", xs: 'center' }, textAlign: "center"
                        }} container item>
                            <MKBox sx={{ display: "inline-block" }}>
                                <MKButton
                                    variant="outlined"
                                    color="primary"
                                    className="upgrade"
                                    size="medium"
                                    sx={{

                                        fontSize: "14px",
                                        borderRadius: "4px",
                                        color: "#50B748",
                                        borderColor: "#50B748",
                                        mr: { xs: "50px", sm: "50px", md: "50px" },
                                        verticalAlign: "middle",
                                        lineHeight: 1.5
                                    }}
                                    onClick={toggleContactUsModal}

                                >
                                    CANCEL
                                </MKButton>
                                <MKButton
                                    variant="contained"
                                    color="primary"
                                    size="medium"
                                    className="upgrade"
                                    sx={{
                                        ':hover': {
                                            bgcolor: '#3CAC33',
                                            color: '#FFFFFF',

                                        },
                                        fontSize: "14px",
                                        borderRadius: "4px",
                                        verticalAlign: "middle"
                                    }}
                                    onClick={updateContactUSForm}
                                >
                                    SUBMIT
                                </MKButton>
                            </MKBox>
                        </Grid>
                    </div>
                }
                {showLoading && <>
                    <div className="contacus-modal-content">
                        <Grid style={{width:"100%", height:'450px'}} alignItems={"center"} justifyContent="center" display="flex" >
                            <MKBox
                                sx={{
                                    
                                    width: "150px",
                                    height: "150px",
                                }}>
                                <Lottie animationData={growLoader} loop={true} />
                            </MKBox>
                        </Grid>
                    </div>
                </>}
                {showConfirm && <>
                    <div className="contacus-modal-content">

                        <MKTypography fontSize="24px" style={{ color: "#202223", letterSpacing: "0.4px", textAlign: "center", opacity: 1, margin: '40px', marginBottom: '0px' }}>

                            We’ve got your request! Our team will connect with you soon to understand your requirements and prepare a tailored solution for your business.
                        </MKTypography>
                        <Grid lg={12} sx={{
                            mt: '32px',
                            mb: '32px',
                            

                            justifyContent: { sm: "center", xs: 'center' }, alignContent: { sm: "center", xs: 'center' }, textAlign: "center"
                        }} container item>
                            <MKBox sx={{ display: "inline-block" }}>
                                <MKButton
                                    variant="outlined"
                                    color="primary"
                                    className="upgrade"
                                    size="medium"
                                    sx={{

                                        fontSize: "14px",
                                        borderRadius: "4px",
                                        color: "#50B748",
                                        borderColor: "#50B748",
                                        mr: { xs: "50px", sm: "50px", md: "50px" },
                                        verticalAlign: "middle",
                                        lineHeight: 1.5
                                    }}
                                    onClick={toggleContactUsModal}

                                >
                                    OKAY
                                </MKButton>
                            </MKBox>
                        </Grid>
                    </div>

                </>}
            </div>

        </>
    )
}

export default PremiumContactUsModal;